var $fc9bc2ec180ca71d$exports = {};
$fc9bc2ec180ca71d$exports = {
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "placeholder": `Kiv\xe1laszt\xe1s\u{2026}`
};


export {$fc9bc2ec180ca71d$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
